import { useLanguage } from "../../i18n/LanguageContext";

export default function LearningCenterPage({
  learningUnits,
  loadingLearning,
  openUnit,
  goBackToHome,
  styles,
}) {
  const { t } = useLanguage();

  return (
    <div style={styles.card}>
      <div style={styles.topBar}>
        <div>
          <h2 style={styles.sectionTitle}>
            {t("learningCenter.title")}
          </h2>

          <div style={styles.quizPath}>
            {t("learningCenter.subtitle")}
          </div>
        </div>

        <button
          style={styles.secondaryButton}
          onClick={goBackToHome}
        >
          {t("learningCenter.backHome")}
        </button>
      </div>

      {loadingLearning ? (
        <div style={styles.emptyBox}>
          {t("learningCenter.loadingUnits")}
        </div>
      ) : (
        <div style={styles.courseGrid}>
          {learningUnits.map((unit) => (
            <div
              key={unit.id}
              style={styles.courseCard}
              onClick={() => openUnit(unit)}
            >
              <div style={styles.courseBadge}>
                {t("learningCenter.unit")}{" "}
                {unit.display_order}
              </div>

              <h3 style={styles.courseCardTitle}>
                {unit.unit_name}
              </h3>

              <div style={styles.quizPath}>
                {unit.description ||
                  t(
                    "learningCenter.defaultUnitDescription"
                  )}
              </div>

              <button
                style={{
                  ...styles.courseButton,
                  marginTop: "16px",
                }}
              >
                {t("learningCenter.startLearning")}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}